import { styled } from '@mui/material/styles'
import { Box, Typography, Menu, Paper, IconButton } from '@mui/material'
// import { reportAuraBackground } from '../../../../assets/images'
import { reportAuraBackgroundCompareV2, reportAuraBackgroundV2 } from '../../../../assets/images'
import { LEGEND_TEXT_COLOR_MAP, thinScrollbar } from '../../../../constants'
import { exportToPPT_tableCss } from '../../../../util'
import { MEDIA } from '../../../../constants'

export const Wrapper = styled(Box)(`
    // padding:20px 30px;
    &.exportToPPT {padding:0; display:flex; align-items:center; flex-direction:column; max-width:1000px; position:relative;}
    &.exportToPPT:before {position:absolute; top:0; right:-2px; width:6px; height:100%; background:#fff; z-index:1; display:block; content:'';} // TEMP HACK ONLY FOR EXPORT TO PPT SCENARIO
    &.exportToPPT > div:first-of-type{scale : 1.2;margin-top:25px;min-height : 450px}
    &.exportToPPT > div:last-child{width:100%;}
    &.exportToPPT > div:last-child > div{padding:2px 0;}
    // &.exportToPPT > div, &.exportToPPT > div > div{max-height:600px;}
    // &.exportToPPT .logoWrapper {margin-top:20px;}
    &.exportToPPT .high-impact , &.exportToPPT .low-impact {width : 12%;}
    &.exportToPPT .graphDesc{position:relative; padding-right:0px;}
    
    ${exportToPPT_tableCss}
    @media (max-width: ${MEDIA.lg}) {
        padding: 20px;
    }

    &.scaleLevel1 {transform: scale(0.83);}
    /* &.scaleLevel1 > div:first-of-type{margin-left:-40px;} */

    &.scaleLevel2 {transform: scale(0.73);}
    /* &.scaleLevel2 > div:first-of-type{margin-left:-84px;} */

    &.scaleLevel3 {transform: scale(0.7);}
    /* &.scaleLevel3 > div:first-of-type{margin-left:-95px;} */
`)

export const OuterWrapper = styled(Box)(
  (props) => `
    background:#fff url(${props.compareAura ? reportAuraBackgroundCompareV2 : reportAuraBackgroundV2}) no-repeat calc(100% - 50% - 4px) ${props.compareAura ? '30px' : '45px'};
    width:100%;
    height:${props.height ? props.height : '423px'};
    min-width:${props.minWidth ? props.minWidth : '900px'};
    /* min-width:1075px; */
    position: relative;

    ${props.compareAura ? `
      max-width: calc(100% - 650px);
      margin: 0 auto;
    ` : ''}

    // ${props.compareAura ? `
    //   .rows span:hover {
    //     cursor : default;
    //   }
    // ` : ''}
`)

export const InnerWrapper = styled(Box)(`
    display:flex; flex-direction: column;
    // height:570px; 
    width:100%; 
    padding-top: 30px;
    /* max-width:calc(100% - 10px); */

    &.popupAura {
      padding-top : 0px;
    }

    &.AuraWithoutSentiments , &.AuraWithoutSentimentsAndProgression{
        span:before {display: none;}
        .box1 * , .box1 {color: #0A286E !important;}
        .box2 * , .box2 {color: #143C98 !important;}
        .box3 * , .box3 {color: #2756C3 !important;}
        .box4 * , .box4 {color: #4275E9 !important;}

        div lhs span,
        div rhs span { color:red; }
    }
`)

export const Row = styled(Box)(`
    width:100%; display:flex; justify-content: space-between; font-family: 'Poppins'; font-style: normal; letter-spacing: 0; text-transform: lowercase; line-height: 1;
    font-weight:400 !important;
    position: relative;
    
    & .Negative{color:${LEGEND_TEXT_COLOR_MAP.Negative}; }
    & .Negative:before{content:'-'}

    & .Positive{color:${LEGEND_TEXT_COLOR_MAP.Positive}; }
    & .Positive:before{content:'+'}

    // Mixed Color Old
    & .Mixed{color:#636B73; }
    // & .Mixed{color:${LEGEND_TEXT_COLOR_MAP.MixedNegative}; }
    & .Mixed:before{content:'~'}

    & span.hightLight-text {
      font-weight: 700;
    }

    & span:hover {
      transform: translateX(2px);
      transition: transform 0.2s ease;
      cursor: pointer;
    }

    & .lhs-row {
      & span:hover {
        transform: translateX(-2px);
      }
    }
`)

export const Lhs = styled(Box)(`
    width:50%; text-align:right; display:flex; justify-content:end;
    & span{margin-left:5px; text-wrap-mode:nowrap;}
`)

export const Rhs = styled(Box)(`
    width:50%; text-align:left; display:flex; justify-content:start;
    & span{margin-right:5px; text-wrap-mode:nowrap;}
`)

export const Logo = styled(Box)(`
    position: absolute;
    bottom: calc(5% + 65px);
    left: calc(50% - 115px);
    width: 220px;
    height: 200px;
    display: flex;
    align-items: end;
    justify-content : center;

    & img {
     width: auto;
     max-width : 200px;
     max-height: 200px;
    }

    &.compareAura {
    left: calc(50% - 73px);
    width : 145px;
    height : 170px;

      & img {
        max-height : 100px;
        max-width : 150px;
      }
    }
`)

export const Impact = styled(Box)(`
    position: absolute;
    color : rgba(104, 104, 103, 1);
    font-size : 13px;
    line-height : 16px;

    &.compareAura {
      font-size : 12px;
    }

    &::after {
      content: "";
      position: absolute;
      width: 25px;
      height: 7px;
    }
    
    &.high-impact {
      top: calc((50% - 115px) + 20px);
      left: calc(50% - 45px);
      
      &.compareAura {
        top: calc((50% - 95px) + 5px);
        left: calc(50% - 40px);
      }
  
      &::after {
        top: -10px;
        left: 25px;
        background-color: #70B1FE;
        clip-path: polygon(50% 0%, 100% 100%, 0% 100%);
      }
    }
    
    &.low-impact {
      bottom: calc((50% - 186px) + 15px);
      left: calc(50% - 45px);

      &.compareAura {
        bottom: calc((50% - 160px) + 25px);
        left: calc(50% - 40px);
      }
      
      &::after {
        bottom: -9px; 
        left: 24px;   
        background-color: #C9E2FF;
        clip-path: polygon(0% 0%, 100% 0%, 50% 100%);
      }
    }
`)

export const GraphDescription = styled(Box)(`
    // width:100%;
    // min-height:20px;
    // display:flex;
    // background:#f1f1f1;
    // border:0 !important;
    // & * {
    //     border:0 !important;
    //     margin:0 !important;
    //     padding:0 !important;
    // }
    p {
        font-size:12px;
        font-weight:300;
    }
`)

export const GraphLegendWrapper = styled(Box)(
  (props) => `
    display:flex;
    padding:${props.padding ? props.padding : '10px 0'};
    justify-content: end;
`)

export const GraphLegend = styled(Typography)(
  (props) => `
    font-weight: 300;
    font-size: 10px;
    line-height: 14px;
    letter-spacing: -0.01em;
    text-transform: capitalize;
    color: #000;
    margin-right:10px;
    display: flex;
    align-items: baseline;

    &:before{
        content:'';
        background:${props.color};
        width:8px;
        height:8px;
        display:block;
        margin-right:5px;
    }
`
)

export const MenuWrapper = styled(Menu)(`
    box-shadow: 0px 0px 14px rgba(0, 0, 0, 0.15);
    padding:40px 0 20px;
    z-index:12;
`)

export const MenuWrapper_ = styled(Paper)(`
    background: #F4F8FF;
    box-shadow: 0px 0px 14px rgba(0, 0, 0, 0.15);
    position:fixed;
    padding:40px 0 20px;
`)

export const MenuContent = styled(Box)(`
    // padding:10px 10px 0 10px;
    overflow:static;
    // width: 550px;
    width: 745px;

    // max-height : calc(100% - 61px - 32px);
    // overflow-y : auto;
`)

export const MenuClose = styled(IconButton)(`
    position: absolute;
    right: 1%;
    top: 0%;
`)

export const ModalWrapper = styled(Box)(`
  .modal-title-popup {
    &:before {
      margin-right : 5px;
    }
    
    &.Negative{color:${LEGEND_TEXT_COLOR_MAP.Negative} !important; }
    &.Negative:before{content:'-'}

    &.Positive{color:${LEGEND_TEXT_COLOR_MAP.Positive} !important; }
    &.Positive:before{content:'+'}

    // Mixed Color Old
    &.Mixed{color:#636B73 !important; }
    // &.Mixed{color:${LEGEND_TEXT_COLOR_MAP.MixedNegative} !important; }
    &.Mixed:before{content:'~'}
    
    
    &.AuraWithoutSentiments:before{display:none;}
  }

`)

export const TopAuraWrapper = styled(Box)(`
  display : flex;
  gap : 40px;

  & > .MuiBox-root:first-of-type {
    margin-left : 32px;
  }

  & > .MuiBox-root:nth-child(2) {
    margin-right : 32px;
  }
`)

export const AuraModalWrapper = styled(Box)((props) => `
  max-height : ${props.modalheight ? `${props.modalheight}px` : '740px'};
  overflow-y : scroll;
  ${thinScrollbar.styles}
`)

export const AuraMainModal = styled(Box)(`
  & .aura-popup {
    top : 5px; 

    .PopupWrapper {
      .popupTitle {
        padding : 10px 80px 10px 28px;
      }

      .closeBtn {
        top : -1px;
      }

      .popupContent {
        padding : 0px 28px 5px;

        .TopAuraWrapper  {
          padding-top : 5px;
        }
      }
    }
  }

  &.sm-screen {
    & .TopAuraWrapper {
      flex-direction : column;
      gap : 20px !important;

      &>.MuiBox-root:first-of-type {
        margin-left: 0 !important;
        margin-right : 0 !important;
        min-width : 1000px;
      }

      &>.MuiBox-root:nth-child(2) {
        margin-right: 0 !important;
        margin-left : 0 !important;
        margin-bottom : 20px;
        min-width : 1000px;
      }
    }
  }

   &.mid-screen {
    .popupContent {
      padding: 0 5px 5px !important;

      .AuraModalWrapper {
        // max-height: 660px;

        & .TopAuraWrapper {
          gap: 10px;

          &>.MuiBox-root:first-of-type {
            margin-left: 10px;
          }

          &>.MuiBox-root:nth-child(2) {
            margin-right: 10px;
          }
        }
      }
    }
  }
`)

export const SelectWrapper = styled(Box)(`
  top: calc((50% - 80px) + 20px);
  left: calc(50% - 42px);
  position: absolute;

  &.progression-name {
    top: calc((50% - 72px) + 20px);
    left: calc(50% - 26px);
  }

  & .selectWrap {
    border: none !important;

    & .MuiInputBase-root {
      text-align: center;
      padding-left: 0 !important;
      flex-direction : column;

      .MuiSelect-select {
        padding-right: 0;
        font-size: 13px;
        height : 26px;
        // get color From global 
        color : rgba(0, 0, 0, 1);
        padding-bottom : 20px;
      }

      svg {
        top: 25px;
        right: 30px;
        cursor : pointer;
      }
    }
  }
`)

export const RightLineSvg = styled(Box)(`
  right: 23%;
  top: 11%;
  position: absolute;
`)

export const LeftLineSvg = styled(Box)(`
  left: 23%;
  top: 11%;
  position: absolute;
`)